import { useRouter } from 'next/router';

import { resolveCoreLocale } from '@zep/i18n';
import { Language } from '@zep/types/common';

export function useLocale(): Language {
  const { locale } = useRouter();
  return resolveCoreLocale(locale);
}
